import {Component, OnInit, Inject, DestroyRef, inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {TagService} from '@emm/core/services/tag.service';
import {ManagementApiService} from '@emm/management/services/management-api.service';
import {Consumer} from '@emm/core/models/consumer.model';
import {SalesChannel} from '@emm/core/models/sales-channel.model';

@Component({
    selector: 'emm-add-consumer-dialog',
    styleUrls: ['./add-consumer-dialog.component.scss'],
    templateUrl: './add-consumer-dialog.component.html',
    standalone: false
})
export class AddConsumerDialogComponent implements OnInit {
    private readonly destroyRef: DestroyRef = inject(DestroyRef);
    form: FormGroup;

    consumerTypes$ = this.managementApiService.getConsumerTypes();
    salesChannels: SalesChannel[] = [];

    constructor(
        public dialogRef: MatDialogRef<AddConsumerDialogComponent>,
        public tagService: TagService,
        public managementApiService: ManagementApiService,
        @Inject(MAT_DIALOG_DATA) public data: any) {}

    ngOnInit(): void {
        this.managementApiService.getAllSalesChannels().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
            result => {
                this.salesChannels = result.filter(salesChannel => salesChannel.tag !== 'ORDERING');
            });
        this.dialogRef.updatePosition({ top: '100px' });
        this.buildForm();
    }

    closeAfterSubmit(): void {
        const result = {
                name: this.form.controls.name.value,
                tag: this.form.controls.tag.value,
                destinationType: this.form.controls.destinationType.value,
                consumerCategory: this.data.categoryData.id,
                description: this.form.controls.description.value,
                salesChannelList: this.form.controls.salesChannels.value
            } as Consumer;
        this.dialogRef.close(result);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    buildForm(): void {
        this.form = new FormGroup({
            name: new FormControl(''),
            tag: new FormControl(''),
            destinationType: new FormControl(''),
            consumerCategory: new FormControl(''),
            description: new FormControl(''),
            salesChannels: new FormControl(['ORDERING'])
        });
    }

    findTagExists(): void {
        if (this.form.controls.tag.valid) {
            this.tagService.getConsumerTags(this.form.get('tag').value)
                .pipe(
                    takeUntilDestroyed(this.destroyRef)
                )
                .subscribe(res => {
                    if (res) {
                        this.form.controls.tag.setErrors({ tagExists: true });
                    }
                });
        }
    }

    OnSubmit(): void {
        if (this.form.valid) {
            this.closeAfterSubmit();
        }
    }

}
